/**
 * AppearanceScreen — one question at a time.
 *
 * Sub-cards:
 *  0  hasTattoos          (yes/no)
 *  1  acceptsPartnerTattoos (yes/no — last)
 */
import { useState } from "react";
import { Button } from "../components/Button";
import { QuestionCard } from "../components/QuestionCard";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

const TOTAL = 2;

export function AppearanceScreen() {
  const { profileAnswers, setProfileAnswers, next, canContinue } = useFlow();
  const t = useT();
  const a = profileAnswers.appearance;

  const patch = (partial: Partial<typeof a>) =>
    setProfileAnswers((p) => ({ ...p, appearance: { ...p.appearance, ...partial } }));

  const [card, setCard] = useState(0);
  const pos = t("questionnaire.progressLabel", { current: String(card + 1), total: String(TOTAL) });
  const goBack = () => setCard((i) => Math.max(i - 1, 0));

  /* ── Sub-card 0: Has tattoos ── */
  if (card === 0) {
    return (
      <div className="screen-enter" style={{ flex: 1 }}>
        <QuestionCard question={t("appearance.hasTattoos")} position={pos}>
          <div className="q-options">
            <button
              type="button"
              className={`q-option${a.hasTattoos === true ? " is-selected" : ""}`}
              onClick={() => { patch({ hasTattoos: true }); setCard(1); }}
              aria-pressed={a.hasTattoos === true}
            >
              <strong>{t("common.yes")}</strong>
            </button>
            <button
              type="button"
              className={`q-option${a.hasTattoos === false ? " is-selected" : ""}`}
              onClick={() => { patch({ hasTattoos: false }); setCard(1); }}
              aria-pressed={a.hasTattoos === false}
            >
              <strong>{t("common.no")}</strong>
            </button>
          </div>
        </QuestionCard>
      </div>
    );
  }

  /* ── Sub-card 1 (last): Accepts partner tattoos ── */
  return (
    <div className="screen-enter" style={{ flex: 1 }}>
      <QuestionCard question={t("appearance.acceptsPartner")} position={pos}>
        <div className="q-options">
          <button
            type="button"
            className={`q-option${a.acceptsPartnerTattoos === true ? " is-selected" : ""}`}
            onClick={() => patch({ acceptsPartnerTattoos: true })}
            aria-pressed={a.acceptsPartnerTattoos === true}
          >
            <strong>{t("common.yes")}</strong>
          </button>
          <button
            type="button"
            className={`q-option${a.acceptsPartnerTattoos === false ? " is-selected" : ""}`}
            onClick={() => patch({ acceptsPartnerTattoos: false })}
            aria-pressed={a.acceptsPartnerTattoos === false}
          >
            <strong>{t("common.no")}</strong>
          </button>
        </div>
        <button type="button" className="q-subnav__back" style={{ marginTop: 16 }} onClick={goBack}>
          ← {t("shell.back")}
        </button>
      </QuestionCard>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.continue")}
        </Button>
      </div>
    </div>
  );
}
